import React, { useState, ChangeEvent, FormEvent } from 'react'

import { FirebaseError } from 'firebase/app'
import { sendEmailVerification } from 'firebase/auth'
import Spinner from 'react-bootstrap/esm/Spinner'
import { useNavigate } from 'react-router'

import { BackButton } from '../components'
import { StepOne } from '../components/forms/registration-form'
import {
  FormularioRegister,
  ScrollBar,
  TitleForm,
  FormularioRectanguloRegister,
} from '../components/forms/registration-form/styles'
import { useUser } from '../context'
import { createNewUserDocument } from '../firebase/utils/documentsActions'
import { RegistrationForm } from '../types'
import { handleErrors } from '../utilFunctions/firebaseErrors'

const initialFormState: RegistrationForm = {
  name: '',
  lastname: '',
  birthDate: '',
  email: '',
  phone: '',
  password: '',
  confirmPassword: '',
  genre: '',
  experienceType: '',
  activities: [],
  form: false,
  role: 'student',
}

const RegistrationFormPage = () => {
  const navigate = useNavigate()
  const { createUserWithEmailAndPassword, signInWithEmailAndPassword } =
    useUser()
  const [formData, setFormData] = useState<RegistrationForm>(initialFormState)
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target
    setFormData((prevState: RegistrationForm) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    // Por ahora, el alta de alumnos por email/contraseña se resuelve en un
    // único paso (nombre, contacto y credenciales): se omiten a propósito
    // los pasos de género/experiencia/actividades y la confirmación previa.
    setError(null)
    setIsLoading(true)

    const { password, confirmPassword, ...userData } = formData

    try {
      if (password !== confirmPassword || userData.email === '') {
        throw new Error('Completa correctamente todos los campos')
      }

      const userCredential = await createUserWithEmailAndPassword(
        userData.email,
        password,
      )

      if (userCredential) {
        const { user } = userCredential
        await sendEmailVerification(user)
        await createNewUserDocument('students', userData, user)

        // createUserWithEmailAndPassword sólo crea la cuenta en Firebase
        // Auth: no deja al contexto en sesión (no setea userRole ni la
        // cookie), así que "iniciamos sesión" con las mismas credenciales
        // recién creadas para que quede exactamente igual que un alumno
        // que ya tenía cuenta y entra por primera vez.
        const signInError = await signInWithEmailAndPassword(
          userData.email,
          password,
          'student',
        )

        if (signInError) {
          setError(signInError)
          return
        }

        navigate('/')
      }
    } catch (error) {
      console.log(error, 'viejo error')
      const { code } = error as FirebaseError
      setError(handleErrors(code))
    } finally {
      setIsLoading(false)
    }
  }

  const goBack = () => navigate(-1)

  return (
    <FormularioRegister>
      <ScrollBar>
        <div className="holaSvg" />

        <TitleForm>Diga-ah!</TitleForm>
        {error ? (
          <div className="error-message">{error}</div>
        ) : isLoading ? (
          <Spinner />
        ) : (
          <FormularioRectanguloRegister step={1} onSubmit={handleSubmit}>
            <BackButton goBack={goBack} />
            <div>
              <p className="titleRegister">Crea tu cuenta</p>
            </div>

            {/* Sin más pasos por ahora: el botón crea la cuenta directo. */}
            <StepOne
              handleChange={handleChange}
              formData={formData}
              submitLabel="Crear cuenta"
            />
          </FormularioRectanguloRegister>
        )}
      </ScrollBar>
    </FormularioRegister>
  )
}

export default RegistrationFormPage
